// extracted by mini-css-extract-plugin
export var modalFooter = "_sy-0";